import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment from 'moment-timezone';

Vue.config.productionTip = false;

// Check for login
router.beforeEach((to, from, next) => {
  if (store.getters.isLoggedIn || to.meta.requireLogin === false) {
    next();
  } else {
    next({ name: 'Login', params: { next: to.fullPath } });
  }
});

// Redirect to the login page if authentication fails
store.commit('setAuthFailureHandler', () => {
  router.push({ name: 'Login' });
});

Vue.filter('date', (value: string | Date | moment.Moment) => moment(value).format('DD/MM/YYYY'));
Vue.filter('time', (value: string | Date | moment.Moment) => moment(value, 'HH:mm:ss').format('HH:mm'));

export function formatDatetime(value: string | Date | moment.Moment) {
  return moment(value).format('DD/MM/YYYY HH:mm');
}

Vue.filter('datetime', formatDatetime);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
